import { useMutation } from "react-query";
import { secureBotAxios } from "../_helpers/auth";
import { botLocalAxios } from "./bot";

export const usePostOnInstagram = (onSuccess) => {
    return useMutation((data) => {
        return (
            secureBotAxios
                // return botLocalAxios
                .post(`/social/instagram/post`, data)
                .then((res) => {
                    return res?.data;
                })
                .then((res) => {
                    onSuccess(res);
                })
        );
    });
};

export const useRenderCreation = (onSuccess) => {
    return useMutation((data) => {
        return (
            secureBotAxios
                // return botLocalAxios
                .post(`/render/render_creation`, data)
                .then((res) => {
                    return res?.data;
                })
                .then((res) => {
                    onSuccess(res);
                })
        );
    });
};

export const useWriteCaption = (onSuccess) => {
    return useMutation((data) => {
        return secureBotAxios
            .post(`/gen/caption`, data)
            .then((res) => {
                return res?.data;
            })
            .then((res) => {
                onSuccess(res);
            });
    });
};
